"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NotificationBar = _interopRequireDefault(require("./../NotificationBar"));

var _NotificationItem = _interopRequireDefault(require("./../NotificationItem"));

var _phoneNumberHelper = require("@eig-builder/core-utils/helpers/phone-number-helper");

var _map = _interopRequireDefault(require("lodash/map"));

var _get = _interopRequireDefault(require("lodash/get"));

var NotificationBarWithMessages = function NotificationBarWithMessages(props) {
  var supportedReplaceTags = [{
    type: '{SupportPhonenumber}',
    replacement: (0, _phoneNumberHelper.getSupportPhoneNumber)()
  }];
  /**
   * @param {array} tags, available tags, defined in constructor
   * @param {array} message, split string of the message returned from the server
   */

  var isInSupportedTags = function isInSupportedTags(tags, message) {
    return message.find(function (msg) {
      return tags.includes(msg);
    });
  };
  /**
   * check and replace tags found in the message
   * caveat: this assumes no dot on the end of the message
   * @param {array} tags available tags
   * @param {string} message to replace tag with
   */


  var checkMessageOnTags = function checkMessageOnTags(tags, message) {
    if (typeof message === 'string') {
      var tagsFromConstructor = tags.map(function (tag) {
        return tag.type;
      }); // our tag could have a dot at the end

      var messageWithoutdots = message.replace(/\./g, '').split(' ');
      var foundTag = isInSupportedTags(tagsFromConstructor, messageWithoutdots); // if we found a tag replace it, else just return the message

      if (foundTag) {
        var getReplacementText = tags.filter(function (tag) {
          return tag.type === foundTag;
        });
        return getReplacementText[0] && replaceTagWithVar(foundTag, message, getReplacementText[0].replacement);
      }
    }

    return message;
  };
  /**
   * replace our tags with the actual replacement tag
   * @param {string} tag to replace
   * @param {string} message to replace tag in
   * @param {string} replacement string
   */


  var replaceTagWithVar = function replaceTagWithVar(tag, message, replacement) {
    return message.replace(tag, replacement);
  };

  var convertReduxMessageToNotificationItem = function convertReduxMessageToNotificationItem(item, index) {
    var fullWidth = props.targetKey === 'wizard';
    var dispatch = props.dispatch,
        hideBar = props.hideBar;

    if ((0, _get["default"])(item, 'version') === 2) {
      item.message = checkMessageOnTags(supportedReplaceTags, item.message);
      return _react["default"].createElement(_NotificationItem["default"], (0, _extends2["default"])({
        key: index
      }, item, {
        fullWidth: fullWidth,
        onClose: function onClose() {
          item.onClose && item.onClose();
          hideBar(item.id)(dispatch);
        }
      }));
    } else {
      var type = (0, _get["default"])(item, 'type');
      var variant = type;

      if (type === 'hint' || type === 'neutral') {
        variant = 'default';
      }

      return _react["default"].createElement(_NotificationItem["default"], {
        fullWidth: fullWidth,
        key: index,
        variant: variant,
        message: checkMessageOnTags(supportedReplaceTags, (0, _get["default"])(item, 'message')),
        onClose: function onClose() {
          hideBar(item.id)(dispatch);
        }
      });
    }
  };

  return _react["default"].createElement(_NotificationBar["default"], (0, _extends2["default"])({
    variant: props.targetKey
  }, props), (0, _map["default"])(props.messages, convertReduxMessageToNotificationItem));
};

NotificationBarWithMessages.propTypes = {
  targetKey: _propTypes["default"].oneOf(['fullscreen', 'wizard', 'page']),
  messages: _propTypes["default"].array,
  hideBar: _propTypes["default"].func.isRequired,
  dispatch: _propTypes["default"].func
};
NotificationBarWithMessages.defaultProps = {
  targetKey: 'fullscreen'
};
var _default = NotificationBarWithMessages;
exports["default"] = _default;